import { useUiVersion } from 'hooks';

import { CustomSelect } from './CustomSelect';

export const Select = (props) => {
  const { className, label, input, children, disabled, onlyInput = false, placeholder, width } = props;
  const { isNew } = useUiVersion();

  return (
    <div className={className}>
      {!onlyInput && <label>{label}</label>}
      {isNew ? (
        <CustomSelect input={input} disabled={disabled} placeholder={placeholder} width={width}>
          {children}
        </CustomSelect>
      ) : (
        <select {...input} disabled={disabled}>
          {children}
        </select>
      )}
    </div>
  );
};
